var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { Popup } from '@progress/kendo-react-popup';
import { InlineEdit } from '@components/v2/InlineEdit';
import { Button } from '@ui';
function TimeZoneDropdown(_a) {
    var _b;
    var { variant = 'default' } = _a, params = __rest(_a, ["variant"]);
    const selectedElement = useMemo(() => {
        var _a;
        return (_a = params.timeZoneList) === null || _a === void 0 ? void 0 : _a.find((option) => option.value === params.selectedValue);
    }, [params.timeZoneList, params.selectedValue]);
    const anchor = useRef(null);
    const popup = useRef(null);
    const [show, setShow] = useState(false);
    const handleItemClick = (element) => {
        params.onChange(element.value);
        setShow(false);
    };
    const handleBodyClick = useCallback((e) => {
        var _a, _b;
        if (popup.current && ((_a = popup.current._popup) === null || _a === void 0 ? void 0 : _a.contains(e.target)))
            return;
        if (anchor.current && ((_b = anchor.current) === null || _b === void 0 ? void 0 : _b.contains(e.target)))
            return;
        setShow(false);
    }, []);
    useEffect(() => {
        document.body.addEventListener('click', handleBodyClick);
        return () => {
            document.body.removeEventListener('click', handleBodyClick);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        variant === 'inline-edit' ? (React.createElement(InlineEdit, { id: "timezone-popup-button", refComp: anchor, variant: "dropdown", onClick: () => setShow(!show) }, selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.label)) : (React.createElement(Button, { isMenu: true, ref: anchor, onClick: () => setShow(!show) },
            React.createElement("i", { className: "fa-light fa-clock-five" }),
            " ", selectedElement === null || selectedElement === void 0 ? void 0 :
            selectedElement.label)),
        React.createElement(Popup, { anchor: anchor.current, show: show, ref: popup, anchorAlign: { horizontal: 'right', vertical: 'bottom' }, popupAlign: { horizontal: 'right', vertical: 'top' } },
            React.createElement("div", { className: "qmb-popup--action-list", style: { maxWidth: 'none', maxHeight: '40rem', overflowY: 'scroll' } },
                React.createElement("div", { className: "popup__section" },
                    React.createElement("ul", { role: "presentation" }, (_b = params.timeZoneList) === null || _b === void 0 ? void 0 : _b.map((timeZone) => (React.createElement("li", { key: timeZone.value },
                        React.createElement(Button, { onClick: () => handleItemClick(timeZone) }, timeZone.label))))))))));
}
export default TimeZoneDropdown;
